import { render, staticRenderFns } from "./profile1.vue?vue&type=template&id=21e772b3&"
import script from "./profile1.vue?vue&type=script&lang=js&"
export * from "./profile1.vue?vue&type=script&lang=js&"
import style0 from "./profile1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports